import { useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import constate from 'constate'
import queryString from 'query-string'
import { UserScrapType } from 'generated/graphql'
import { MOBILE_BUTTON_SIZE, PC_BUTTON_SIZE } from 'constants/paginations'
import usePagination from 'hooks/usePagination'
import { parseValues } from 'utils/utils'

export interface ScrapState {
  q?: string
  tab?: UserScrapType
  p?: number
}

interface UseScrapStateProps {
  scrapState: ScrapState
  onScrapStateChange?: (newState: ScrapState) => void
}

function initializeState(newState: ScrapState, updatedState: ScrapState) {
  if (!Object.keys(updatedState).includes('p')) {
    newState.p = 1
  }

  return newState
}

function useScrapState(props?: UseScrapStateProps) {
  const { scrapState, onScrapStateChange } = props || {}

  function handleScrapStateChange(updatedState: ScrapState) {
    let newState = {
      ...scrapState,
      ...queryString.parse(window.location.search),
      ...updatedState,
    }

    newState = initializeState(newState, updatedState)
    newState = parseValues(newState, { parseNumbers: true })

    if (onScrapStateChange) {
      onScrapStateChange(newState)
    }
  }

  function setTabState(newTabState: UserScrapType) {
    handleScrapStateChange({ tab: newTabState })
  }

  function setActivePage(newActivePage: number) {
    handleScrapStateChange({ p: newActivePage })
  }

  const theme = useTheme()
  const isSMDown = useMediaQuery(theme.breakpoints.down('sm'))

  const pagination = usePagination({
    activePage: scrapState?.p || 1,
    setActivePage,
    maxButtons: isSMDown ? MOBILE_BUTTON_SIZE : PC_BUTTON_SIZE,
  })

  return {
    tabState: scrapState?.tab || UserScrapType.ACTIVITY,
    setTabState,
    page: scrapState?.p || 1,
    pagination,
  }
}

export const [ScrapStateContextProvider, useScrapStateContext] =
  constate(useScrapState)
